import { DELETE, GET, POST, PUT } from './api';

const table = 'bankings';

export const Create = async (params) => {
  return await POST(`/${table}`, params, true);
};

export const Read = async (filters = '') => {
  return await GET(`/${table}${filters}`, true);
};

export const ReadOne = async (id) => {
  return await GET(`/${table}/${id}?populate=*`, true);
};

export const Update = async (params, id) => {
  return await PUT(`/${table}/${id}`, params, true);
};

export const Delete = async (id) => {
  return await DELETE(`/${table}/${id}`, true);
};

export const UpdateCredito = async (params, id) => {
  return await PUT(`/${table}/updatecredito/${id}`, params, true);
};

export const UpdateParecer = async (params, id) => {
  return await PUT(`/${table}/updateparecer/${id}`, params, true);
};

export const UpdateMotor = async (params, id) => {
  return await PUT(`/${table}/updatemotor/${id}`, params, true);
};
